import jQuery from 'jquery';

// css
import '../buyside/styles/core/base.scss';
import '../buyside/styles/core/utility.scss';
import '../buyside/styles/module/buttons.scss';
import '../buyside/styles/module/cards.scss';
import '../buyside/styles/module/compliance.scss';
import '../buyside/styles/module/header.scss';
import '../buyside/styles/module/icons.scss';
import '../buyside/styles/module/page-titles.scss';
import '../buyside/styles/module/showcase.scss';
import '../buyside/styles/module/tables.scss';
import '../buyside/styles/module/type.scss';

// Fix default browser styles
import './styles/normalize.scss';

// Vendor
import './styles/colorbox.scss';
import './styles/extend-colorbox-more.scss';

// Bootstrap
import './styles/bootstrap/bootstrap.min.css';

// CSS Modules
import './styles/create-account2.scss';
import './styles/headings.scss';
import './styles/promotion.scss';
import './styles/sidebar.scss';
import './styles/spinner.scss';
import './styles/update_notification_preferences.scss';
import './styles/ng-tags-input.min.scss';
import './styles/ng-tags-input.bootstrap.min.scss';
import './styles/modal.scss';
import './styles/external_splash_pages.scss';

// Core
import './styles/core/base.scss';

// JS
// ----------------------------------------------------

// jQuery
window.$ = jQuery;

// Local Scripts
import 'buyside/scripts/polyfill/string-repeat-polyfill';
import 'shared/scripts/index';
import './autocomplete';
import './bootstrap-collapse';
import './bootstrap-modal';
// import './bootstrap.min.js';
import './jquery.cycle';
import './jquery.easing';
import './jquery_validate';
import './products';
import './social_module_follow';
